import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ['dialog', 'option', 'label', 'submit', 'error'];

  openDialogFromAttribute = false;
  errorMessage = '';

  connect() {
    super.connect();
    this.openDialogFromAttribute = this.dialogTarget.dataset.reopenDialog === 'true';
    this.errorMessage = this.dialogTarget.dataset.errorMessage || '';
    if (this.openDialogFromAttribute && this.hasDialogTarget) {
      this.dialogTarget.showModal();
      if (this.errorMessage && this.hasErrorTarget) {
        this.errorTarget.textContent = this.errorMessage;
        this.errorTarget.classList.remove('hidden');
      }
    }
  }

  openDialog() {
    if (this.hasOptionTarget) {
      this.optionTargets.forEach(input => input.checked = false);
    }
    if (this.hasLabelTarget) {
      this.labelTargets.forEach(label => label.classList.remove('active'));
    }
    if (this.hasDialogTarget) {
      this.dialogTarget.showModal();
    }
    document.addEventListener('keydown', this._closeOnEscapeKeyDown);
  }

  closeDialog() {
    if (this.hasDialogTarget) {
      this.dialogTarget.close();
    }
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden');
      this.errorTarget.textContent = '';
    }

    this.dialogTarget.dataset.reopenDialog = 'false';
    this.dialogTarget.dataset.errorMessage = '';
    document.removeEventListener('keydown', this._closeOnEscapeKeyDown);
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.closeDialog();
    }
  }

  toggleActive() {
    let checked = false;
    this.labelTargets.forEach(label => label.classList.remove('active'));
    this.optionTargets.forEach((input, i) => {
      if (input.checked) {
        this.labelTargets[i].classList.add('active');
        checked = true;
      }
    });

    this.submitTarget.disabled = !checked;
  }

  _closeOnEscapeKeyDown = (event) => {
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.closeDialog();
    }
  }
}